import { render, staticRenderFns } from "./DocumentMarginsModal.vue?vue&type=template&id=abb319d0&scoped=true&"
import script from "./DocumentMarginsModal.vue?vue&type=script&lang=js&"
export * from "./DocumentMarginsModal.vue?vue&type=script&lang=js&"
import style0 from "./DocumentMarginsModal.vue?vue&type=style&index=0&id=abb319d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb319d0",
  null
  
)

export default component.exports